// removed by extract-text-webpack-plugin
module.exports = {"list":"_41odIQJ","list_isNZ":"_1-715aj","locale_isActive":"_-DLznfM","localeLink":"_3sLiCPn"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Header/components/Locales/Locales.less
 ** module id = 723
 ** module chunks = 0
 **/